import React from 'react';
import { Link } from 'react-router-dom';

const TermsAndConditions = () => {
  return (
    <div className="bg-background dark:bg-background min-h-[calc(100vh-64px)] py-10">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="bg-card dark:bg-card p-8 rounded-sm border border-border">
          <h1 className="text-3xl font-bold mb-6 text-foreground dark:text-foreground">Terms and Conditions</h1>
          <p className="text-muted-foreground mb-6">Last Updated: May 1, 2025</p>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-foreground dark:text-foreground">Introduction</h2>
            <p className="mb-4 text-muted-foreground">
              These Terms and Conditions ("Terms") govern your use of Testera's AI-powered job assessment platform, accessible via our website and related services (collectively, our "Service").
            </p>
            <p className="mb-4 text-muted-foreground">
              By accessing or using our Service, you agree to be bound by these Terms. If you disagree with any part of the Terms, you may not access the Service.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-foreground dark:text-foreground">User Accounts</h2>
            <p className="mb-4 text-muted-foreground">
              When you create an account with us, you must provide information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account.
            </p>
            <p className="mb-4 text-muted-foreground">
              You are responsible for safeguarding the password that you use to access the Service and for any activities or actions under your password.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-foreground dark:text-foreground">User Roles</h2>
            <h3 className="text-xl font-medium mb-3 text-foreground dark:text-foreground">For Employers</h3>
            <p className="mb-4 text-muted-foreground">
              If you are using our Service as an employer or company representative:
            </p>
            <ul className="list-disc pl-6 mb-4 text-muted-foreground">
              <li>You agree to use candidate assessment data only for legitimate hiring purposes</li>
              <li>You are responsible for ensuring your job listings comply with applicable laws</li>
              <li>You agree not to discriminate against candidates based on protected characteristics</li>
            </ul>
            
            <h3 className="text-xl font-medium mb-3 text-foreground dark:text-foreground">For Candidates</h3>
            <p className="mb-4 text-muted-foreground">
              If you are using our Service as a job candidate:
            </p>
            <ul className="list-disc pl-6 mb-4 text-muted-foreground">
              <li>You agree to provide honest and accurate information about your skills and qualifications</li>
              <li>You understand that employers will receive data about your test performance</li>
              <li>You agree not to cheat, use unauthorized aids, or otherwise compromise test integrity</li>
            </ul>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-foreground dark:text-foreground">Intellectual Property</h2>
            <p className="mb-4 text-muted-foreground">
              The Service and its original content, features, and functionality are and will remain the exclusive property of Testera and its licensors. The Service is protected by copyright, trademark, and other laws.
            </p>
            <p className="mb-4 text-muted-foreground">
              Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of Testera.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-foreground dark:text-foreground">Subscription and Payment</h2>
            <p className="mb-4 text-muted-foreground">
              Some parts of the Service are billed on a subscription basis. You will be billed in advance on a recurring and periodic basis, depending on the type of subscription plan you select.
            </p>
            <p className="mb-4 text-muted-foreground">
              At the end of each period, your subscription will automatically renew under the same conditions unless you cancel it or Testera cancels it.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-foreground dark:text-foreground">Limitation of Liability</h2>
            <p className="mb-4 text-muted-foreground">
              In no event shall Testera, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from:
            </p>
            <ul className="list-disc pl-6 mb-4 text-muted-foreground">
              <li>Your access to or use of or inability to access or use the Service</li>
              <li>Any conduct or content of any third party on the Service</li>
              <li>Any content obtained from the Service</li>
              <li>Unauthorized access, use, or alteration of your transmissions or content</li>
            </ul>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-foreground dark:text-foreground">Governing Law</h2>
            <p className="mb-4 text-muted-foreground">
              These Terms shall be governed and construed in accordance with the laws of India, without regard to its conflict of law provisions.
            </p>
            <p className="mb-4 text-muted-foreground">
              Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-foreground dark:text-foreground">Changes to Terms</h2>
            <p className="mb-4 text-muted-foreground">
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days' notice prior to any new terms taking effect.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-foreground dark:text-foreground">Contact Us</h2>
            <p className="mb-4 text-muted-foreground">
              If you have any questions about these Terms, please contact us at:
            </p>
            <p className="text-muted-foreground">
              Email: contact@testera.ai<br />
              Phone: +91 9717100100 | +91 9100167640
            </p>
          </section>
          
          <div className="border-t border-border pt-6 mt-8">
            <Link to="/" className="text-secondary hover:text-secondary/90">
              Return to Homepage
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
